module.exports = __webpack_public_path__ + "77ab09650ee1acd394bd301d468bfe6d.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/icon_chevron_down.svg
// module id = 1363
// module chunks = 73